export default __webpack_public_path__ + "static/media/8-Ibrahim-Hvorfor tror du noen minoriteter blir undertrykt_1.10b6c221.mp4";